<template>
  <div
    class="account-found-container"
    :class="{ 'safety-assistant': safetyAssistant }"
  >
    <h2>{{ $t('login.signInDifferentWay') }}</h2>

    <div v-if="errorMessage" class="mb-5 darkRed--text">
      {{ errorMessage }}
    </div>

    <div class="options-container">
      <OversizedButton
        v-if="!safetyAssistant"
        icon="mdi-cellphone"
        :text="phoneText"
        @click="setPhoneStage"
      />

      <OversizedButton
        icon="mdi-email"
        :text="emailText"
        @click="setEmailStage"
      />

      <OversizedButton
        v-if="!isQrCodeOrOrientationFlow"
        icon="mdi-message-text-outline"
        :text="$t('login.useCode')"
        @click="useCode"
      />

      <OversizedButton
        v-if="!isQrCodeOrOrientationFlow"
        icon="mdi-dots-horizontal"
        :text="$t('login.enterPassword')"
        @click="setStage('password')"
      />
    </div>

    <a
      class="support-link"
      href="https://salussafety.io/contact-support"
      target="_blank"
    >
      {{ $t('login.contactSupport') }}
    </a>
  </div>
</template>

<script>
import { mapActions, mapState, mapGetters } from 'vuex'
import OversizedButton from '@/components/buttons/OversizedButton.vue'

export default {
  components: {
    OversizedButton,
  },
  data() {
    return {
      errorMessage: null,
    }
  },
  computed: {
    ...mapState({
      emailIdentifier: 'emailIdentifier',
      phoneIdentifier: 'phoneIdentifier',
      stage: 'stage',
      user: 'user',
    }),
    ...mapGetters({
      safetyAssistant: 'safetyAssistant',
    }),
    emailText() {
      return this.emailIdentifier
        ? this.$t('login.useDifferentEmail')
        : this.$t('login.useEmail')
    },
    phoneText() {
      return this.phoneIdentifier
        ? this.$t('login.useDifferentPhone')
        : this.$t('login.usePhone')
    },
    isQrCodeOrOrientationFlow() {
      const { qr, redirect_uri } = this.$route.query
      const redirectUri = redirect_uri || ''
      const isQrCode =
        !!qr ||
        redirectUri.includes('/q/') ||
        redirectUri.includes('/public/action/')
      const isWorkflow = redirectUri.includes('/workflow/')
      return isQrCode || isWorkflow
    },
  },
  watch: {
    stage(value) {
      if (value === 'accountFound') {
        this.errorMessage = null
      }
    },
  },
  methods: {
    ...mapActions({
      requestCode: 'requestCode',
      setShowIdentifier: 'setShowIdentifier',
      setStage: 'setStage',
    }),
    setEmailStage() {
      this.setShowIdentifier('email')
      this.setStage('userIdentifier')
    },
    setPhoneStage() {
      this.setShowIdentifier('phone')
      this.setStage('userIdentifier')
    },
    async useCode() {
      try {
        const type = this.phoneIdentifier ? 'phone' : 'email'
        await this.requestCode({ type, client_id: this.$route.query.client_id })
      } catch (err) {
        this.errorMessage = this.$t('login.failedToSendCode')
      }
    },
  },
}
</script>
<style lang="sass">
.account-found-container
  text-align: center
  h2
    font-size: 1rem
    font-weight: bold
    line-height: 1.5
    margin-bottom: 16px

  .options-container
    display: flex
    flex-direction: column
    gap: 16px
    margin-bottom: 24px

  .support-link
    color: $darkBlue
    font-size: 1rem
    font-weight: 500
    text-decoration: none
    &:hover
      font-weight: 500

.theme--dark
  .account-found-container
    h2
      color: $white !important
    .darkRed--text
      color: $darkRed !important
    .support-link
      color: $darkBlue !important
      &:hover
        color: $primaryBlueHover !important

    .oversized-button
      background-color: $whiteOpacity5 !important
      border: 1px solid $darkBorder !important
      &:hover
        background-color: rgba(255, 255, 255, 0.1) !important
        border-color: $darkBorderHover !important
        .oversized-button-icon
          color: $darkBlue !important
      .oversized-button-content, .oversized-button-title
        color: $white !important
      .oversized-button-icon
        color: $darkBlue !important

.safety-assistant
  h2
    color: $white !important
  .darkRed--text
    color: $errorRed !important
  .support-link
    color: $safetyLink !important
    &:hover
      color: $safetyLinkHover !important

  .oversized-button
    background-color: $darkBackgroundAlt !important
    border: 1px solid $darkBorder !important
    &:hover
      background-color: $darkBackgroundAltHover !important
      border-color: $darkBorderHover !important
      .oversized-button-icon
        color: $safetyLinkHover !important
    .oversized-button-content, .oversized-button-title
      color: $safetyLinkHover !important
    .oversized-button-icon
      color: $safetyLink !important
</style>
